import { render, staticRenderFns } from "./point_mall.vue?vue&type=template&id=17f4749f&scoped=true"
import script from "./point_mall.vue?vue&type=script&lang=js"
export * from "./point_mall.vue?vue&type=script&lang=js"
import style0 from "./point_mall.vue?vue&type=style&index=0&id=17f4749f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f4749f",
  null
  
)

export default component.exports